import React from 'react';
import { Badge, createStyles, makeStyles, Tooltip } from '@material-ui/core';

type Props = {
  tooltipTitle: string;
  badgeContent: number;
};

const useStyles = makeStyles(() =>
  createStyles({
    badge: {
      marginLeft: 18,
      '& .MuiBadge-anchorOriginTopRightRectangle': {
        background: '#ffe9c4'
      }
    }
  })
);

export const TooltipBadge: React.FC<Props> = ({ tooltipTitle, badgeContent }) => {
  const { badge } = useStyles();

  return (
    <Tooltip title={tooltipTitle} placement="right-start">
      <Badge badgeContent={badgeContent} className={badge} />
    </Tooltip>
  );
};
